var _Input;
import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';
import { injectScript } from '@atc/dom-fns';
import { Checkbox, Input } from 'reaxl-forms';
import EmailContext from '../EmailContext';
import EmailStaticContent from '../EmailStaticContent';
/**
 *  TCPADisclaimer Checkbox, Text and hidden input fields are responsible for authorizing
 *  auto dialers to contact users under the Telephone Consumer Protection Act (TCPA)
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function TCPADisclaimer(_ref) {
  let {
    disclaimer = '',
    auditVendor = '',
    ...rest
  } = _ref;
  const {
    listing = {}
  } = useContext(EmailContext);
  const enableJornaya = auditVendor !== 'AUTOTRADER';
  const label = disclaimer || EmailStaticContent.promotions.tcpa;
  if (enableJornaya && typeof document !== 'undefined') {
    const isJornayaScriptPresent = document.getElementById('LeadiDscript_campaign');
    if (!isJornayaScriptPresent) {
      const src = '//create.lidstatic.com/campaign/088f6a50-3637-ab0b-2a4c-d035f08b3ed6.js?snippet_version=2';
      injectScript(src, {
        elementAttributes: {
          id: 'LeadiDscript_campaign'
        }
      });
    }
  }
  const id = `leadid_tcpa_disclosure_${listing.id}`;
  return /*#__PURE__*/_jsxs("div", {
    id: "TCPAConsent",
    ...rest,
    children: [enableJornaya && (_Input || (_Input = /*#__PURE__*/_jsx(Input, {
      id: "leadid_token",
      name: "universal_leadid",
      type: "hidden",
      value: ""
    }))), /*#__PURE__*/_jsx(Input, {
      id: "TCPAConsentDisclaimer",
      name: "tcpaDisclaimer",
      type: "hidden",
      value: label
    }), /*#__PURE__*/_jsx(Checkbox, {
      id: id,
      name: "TCPA_OptIn",
      label: label,
      value: true
    })]
  });
}
export default TCPADisclaimer;